import React, { Component } from 'react'
import { reduxForm } from 'redux-form';
import { selectors, actions } from '../sagas/reservation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TextInput } from '../shared/TextInput';
import KmDatePicker from '../shared/KmDatePicker';
import { FormError } from '../shared/FormError'
import '../stylesheets/Reservations.css';
import '../stylesheets/Reservations.sass';
import moment from 'moment';

class FormStepTwo extends Component {
  constructor(props){
    super(props)
    this.submitFormTwo = this.props.submitFormTwo.bind(this)
    this.setReturnDate = this.props.setReturnDate.bind(this)
    this.setBirthdate = this.props.setBirthdate.bind(this)
    this.backOneStep = this.props.backOneStep.bind(this)
  }

  handleCustomSubmit = () => {
    this.submitFormTwo(this.props.formTwo, this.props.company_id)
  }

  render () {
    const { handleSubmit } = this.props
    return(
    <div className={'personal-information-form'}>
      { this.props.errors && Object.keys(this.props.errors).length > 0 && <FormError errors={this.props.errors}/> }
      <form onSubmit={handleSubmit(this.handleCustomSubmit)}>
        <TextInput
          inputClass='reservation-input'
          inputName='firstName'
          placeholderText='First Name'
          label='First Name'
          required
        />
        <TextInput
          inputClass='reservation-input'
          inputName='lastName'
          placeholderText='Last Name'
          label='Last Name'
          required
        />
        <TextInput
          inputClass='reservation-input'
          inputName='email'
          placeholderText='Email'
          label='Email'
          bootstrapValidator='email'
          required
        />
        <TextInput
          inputClass='reservation-input'
          inputName='streetAddress'
          placeholderText='Street Address'
          label='Street Address'
          required
        />
        <TextInput
          inputClass='reservation-input'
          inputName='city'
          placeholderText='City'
          label='City'
          required
        />
        <TextInput
          inputClass='reservation-input'
          inputName='state'
          placeholderText='State'
          label='State'
          required
        />
        <TextInput
          inputClass='reservation-input'
          inputName='zip'
          placeholderText='Zip'
          label='Zip'
          required
        />
        <TextInput
          inputClass='reservation-input'
          inputName='driverLicense'
          placeholderText='Drivers License Number'
          label='Drivers License Number'
          required
        />
        <TextInput
          inputClass='reservation-input'
          inputName='beerConsumptionAddress'
          placeholderText='Beer Consumption Address'
          label='Where beer will be consumed'
          required
        />
        <TextInput
          inputClass='reservation-input'
          inputName='phoneNumber'
          placeholderText='Phone Number'
          label='Phone Number'
          required
        />
        <div className={'double-datepicker'}>
          <KmDatePicker
            label={'Birthdate'}
            date={ this.props.birthdate }
            change={ this.setBirthdate }
            openToDate={moment().subtract(21, 'years') }
            maxDate={ moment().subtract(21, 'years') }
            scrollableYearDropdown
            yearDropdownItemNumber={50}
            showYearDropdown
          />
        </div>
        <button className='reservation-cancel' onClick={ this.backOneStep } >
          Go Back
        </button>
        <button className='reservation-save' type="submit">
          Submit
        </button>
      </form>
    </div>
     )
  }
}

const mapStateToProps = (store) => ({
  reservation: selectors.reservation(store),
  return_date: selectors.return_date(store),
  birthdate: selectors.birthdate(store),
  form_two: selectors.form_two(store),
  errors: selectors.personal_information_errors(store)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

export default (connect(
  mapStateToProps, mapDispatchToProps)(
  reduxForm(
  {
    form: 'reservation_form_two',
    destroyOnUnmount: false
  }
)(FormStepTwo)));



// WEBPACK FOOTER //
// ./src/Reservations/FormTwo.jsx